const EAGLLWIN_EVENT_MAP = {
  // Leave conversion_tracking_id blank for now; fill it in once the backend
  // tracking configuration is finalized in Eagllwin.
  register2: {
    eventName: "game_addiction",
    conversionTrackingId: "251",
    reportOnce: true,
  },
  register: {
    eventName: "active_register",
    conversionTrackingId: "251",
    reportOnce: true,
  },
  recharge: {
    eventName: "active_pay",
    conversionTrackingId: "251",
    reportOnce: true,
  },
};

export default class EagllwinAnalytics {
  constructor() {
    this.sentEventMap = {};

    const sentEventMapStr = localStorage.getItem("eagllwinEventMap");
    if (sentEventMapStr) {
      try {
        this.sentEventMap = JSON.parse(sentEventMapStr) || {};
      } catch (error) {
        console.error("EagllwinAnalytics parse sent map failed", error);
      }
    }
  }

  SendEvent(event) {
    const eventConfig = EAGLLWIN_EVENT_MAP[event];
    if (!eventConfig || !window.egw_track_send) {
      return;
    }
    if (eventConfig.reportOnce && this.sentEventMap[event]) {
      return;
    }

    console.log("EagllwinAnalytics SendEvent", event, eventConfig);
    window.egw_track_send(eventConfig.eventName, {
      conversion_tracking_id: eventConfig.conversionTrackingId,
    });
    if (eventConfig.reportOnce) {
      this.sentEventMap[event] = 1;
      localStorage.setItem("eagllwinEventMap", JSON.stringify(this.sentEventMap));
    }
  }
}

EagllwinAnalytics.GetInstance = () => {
  if (EagllwinAnalytics.instance) {
    return EagllwinAnalytics.instance;
  }
  EagllwinAnalytics.instance = new EagllwinAnalytics();
  return EagllwinAnalytics.instance;
};
